import {
    nFormatter,
    createSeries,
    createSQL,
    seriesHead,
    appendAggregateValues,
    seriesDataItem,
    pickItem,
    isDateTransformation,
    highestModel,
    averageModel,
    missingValuesModel,
    resolve,
    getSeriesColors,
    extractColors
} from "@/components/charts/common";

import { createDataSource } from '@/models/data-source';


export default async function hydrator(parameters, data, chart) {

    const dataSource = createDataSource({});
    dataSource.updateType = "api";

    data.template = resolve("template.value", parameters);
    data.style = resolve("style.value", parameters);
    let extractedColors = extractColors(resolve("colors.value", parameters));
    data.colors = getSeriesColors(extractedColors);
    data.buttonMenu = [];

    try {
        const menu = JSON.parse(parameters.buttonMenu.value);
        if(Array.isArray(menu) && menu.length) {
            data.buttonMenu = menu;
        }
    } catch(error) {
        console.log("error", error);
    }


    try {
        const sqlQuery = parameters.sqlQuery.value;
        const params = {sql: sqlQuery, id: 9000000009};
        const result = await dataSource.request(params);
        data.series = result.data;
        console.log("chart.chartData.list", data.list);

    } catch (err) {
        console.log("next prev error");
    }

}
